/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessGrantedRolesAndUserGroups extends models.AccessGrantedUserGroups {
    getFixupPrototypeFunction() { return AccessGrantedRolesAndUserGroups.fixupPrototype; }

    static newInstance(model: Partial<AccessGrantedRolesAndUserGroups>): AccessGrantedRolesAndUserGroups {
        let obj = Object.assign(new AccessGrantedRolesAndUserGroups(), model);
        AccessGrantedRolesAndUserGroups.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessGrantedRolesAndUserGroups>): AccessGrantedRolesAndUserGroups {
        if (!model) return null;
        return AccessGrantedRolesAndUserGroups.newInstance(<AccessGrantedRolesAndUserGroups> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessGrantedRolesAndUserGroups) {
        if (!obj) return;

        models.AccessGrantedRolesAndUserGroups.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessGrantedRolesAndUserGroups): boolean {
        if (models.AccessGrantedUserGroups.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AccessGrantedRolesAndUserGroups.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.roles) {
            for (let val of this.roles) {
                models.AccessGrantedRoles.fixupPrototype(val);
            }
        }
    }

    /**
     * Roles explicitly denied access by tenant
     */
    roles: Array<models.AccessGrantedRoles>;

}
